import React, { useMemo } from 'react';
import { MemoChart } from './MemoChart';
import { useThemeVersion } from '../../../useTheme';

// Cores fixas (não var(--green-*)/var(--red-*)) — encodam certo/errado/em
// branco, mesmo critério já documentado em StudentTimelinePage.js pros
// boxes de revisão de questão: no tema escuro essas variáveis mantêm o
// mesmo tom claro do tema claro, mas o texto ao redor herdaria a cor clara
// do tema, ficando ilegível.
const COLORS = { Acertos: '#22C55E', Erros: '#EF4444', 'Em branco': '#9E9E9E' };

export const AttemptResultPieChart = ({ correct, wrong, blank }) => {
    const themeVersion = useThemeVersion();

    const entries = useMemo(() => [
        { name: 'Acertos', value: correct },
        { name: 'Erros', value: wrong },
        { name: 'Em branco', value: blank },
    ].filter(d => d.value > 0), [correct, wrong, blank]);

    const chartData = useMemo(() => ({
        labels: entries.map(e => e.name),
        datasets: [{
            data: entries.map(e => e.value),
            backgroundColor: entries.map(e => COLORS[e.name]),
        }],
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [entries]);

    const chartOptions = useMemo(() => ({
        maintainAspectRatio: false,
        // Corte ~62% (innerRadius/outerRadius = 50/80 no Recharts original)
        // — mantém o efeito de rosca em vez de pizza cheia.
        cutout: '62%',
        layout: { padding: 12 },
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    color: getComputedStyle(document.documentElement).getPropertyValue('--text-color'),
                },
            },
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [themeVersion]);

    if (entries.length === 0) return null;

    return (
        <MemoChart type="doughnut" data={chartData} options={chartOptions} style={{ height: '220px' }} />
    );
};
